/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('ProductCtrl', ["$scope", "$dialog", "$timeout", "ProductCategorySrv", "ProductCategoryData", "ProductCategory", "ProductSrv", "ProductData",
    "Product", "ImageData", "ProductView", "ProductCategoryView", "StyleData", "HumanResourceData", "HumanResourceView", "PhysicalResourceData",
    "PhysicalResourceView", "SupplierView", "SupplierData", "VatData", "VatView", "LanguageManager", "gettextCatalog",
    function ($scope, $dialog, $timeout, ProductCategorySrv, ProductCategoryData, ProductCategory, ProductSrv, ProductData,
              Product, ImageData, ProductView, ProductCategoryView, StyleData, HumanResourceData, HumanResourceView, PhysicalResourceData,
              PhysicalResourceView, SupplierView, SupplierData, VatData, VatView, LanguageManager, gettextCatalog) {
        $scope.dd =
            {
                view:
                    {
                        vatsView: [],
                        categoryRootView: null,
                        productsViewIndex: [],//Keep index
                        deletedCategoriesView: [],
                        deletedProductsView: [],
                        imagesView: [],
                        imagesViewFiltered: [],
                        humanResourcesView: [],
                        suppliersView: [],
                        supplierFilter: "",//filer on search
                        styles: StyleData.styles,
                        displaySubConf: 1,
                        tab: 1,
                        subTab: 1,
                        displayError: false,  //Used  to display error message when user click on save,
                        filter: "",
                        filterProductsView: null,
                        filterTimeOut: null,
                        selected: {
                            categoryView: null,
                            productView: null,
                            supplierView: null
                        },
                        edited:
                            {
                                categoryView: null,
                                productView: null,
                                supplierView: null
                            }
                    },
                flowConfig: {
                    target: '/rest/companyImageUpload',
                    method: 'octet',
                    query: {companyCode: $scope.ad.companyCode, type: 'product'},
                    maxChunkRetries: 1,
                    chunkSize: 5 * 1024 * 1024,
                    simultaneousUploads: 4,
                    singleFile: true,
                    testChunks: false,
                    headers: {Authorization: $scope.ad.currentUser.token}
                }
            };

        $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
            if (newValue) {
                if (!$scope.ad.managerMode) {
                    $scope.goToDomain("planningPos", "dashboard");
                }
                var vats = VatData.getActiveList();
                for (var i = 0; i < vats.length; i++)
                    if (vats[i].isUsable)
                        $scope.addVatView(new VatView(vats[i], VatData.getIndexOf(vats[i])));

                var suppliers = SupplierData.getActiveList();
                for (var i = 0; i < suppliers.length; i++)
                    $scope.addSupplierView(new SupplierView(suppliers[i], SupplierData.getIndexOf(suppliers[i]), $scope));
                $scope.dd.view.imagesView = ImageData.getActiveList("");
                $scope.dd.view.imagesViewFiltered = ImageData.getFilteredImages();
                $scope.dd.view.categoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot, ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot), null, $scope);// categoryRoot index  = 0
                $scope.dd.view.categoryRootView.label = "Racine";
                $scope.dd.view.selected.categoryView = $scope.dd.view.categoryRootView;

                var categories = ProductCategoryData.getDeletedList();
                var parentCatView;
                for (var i = 0; i < categories.length; i++) {
                    if (categories[i].parentCategory)
                        parentCatView = $scope.getCategoryView(categories[i].parentCategory);
                    else
                        parentCatView = null;
                    $scope.dd.view.deletedCategoriesView.push(new ProductCategoryView(categories[i], ProductCategoryData.getIndexOf(categories[i]), parentCatView, $scope))
                }
                var products = ProductData.getDeletedList();
                for (var i = 0; i < products.length; i++) {
                    if (products[i].parentCategory)
                        parentCatView = $scope.getCategoryView(products[i].parentCategory);
                    else
                        parentCatView = null;
                    $scope.dd.view.deletedProductsView.push(new ProductView(products[i], ProductData.getIndexOf(products[i]), parentCatView, $scope))
                }
            }
        });

        $scope.addProductViewIndex = function (productView) {
            $scope.dd.view.productsViewIndex.push(productView);
        };
        $scope.getVatView = function (vat) {
            for (var i = 0; i < $scope.dd.view.vatsView.length; i++)
                if ($scope.dd.view.vatsView[i].getModel() === vat)
                    return $scope.dd.view.vatsView[i];

            // Not found : instanciate (could be a deleted)
            var vatView = new VatView(vat, VatData.getIndexOf(vat));
            if (!vat.isDeleted)
                $scope.dd.view.vatsView.push(vatView);
            return vatView;
        }
        $scope.getDefaultVatView = function () {
            for (var i = 0; i < $scope.dd.view.vatsView.length; i++)
                if ($scope.dd.view.vatsView[i].isDefault)
                    return $scope.dd.view.vatsView[i];

        }
        $scope.getSupplierView = function (supplier) {
            //must loop....
            for (var i = 0; i < $scope.dd.view.suppliersView.length; i++)
                if ($scope.dd.view.suppliersView[i].getModel() === supplier)
                    return $scope.dd.view.suppliersView[i];

            // Not found : instanciate (could be a deleted customer)
            var supplierView = new SupplierView(supplier, SupplierData.getIndexOf(supplier), $scope);
            if (!supplier.isDeleted)
                $scope.dd.view.suppliersView.push(supplierView);
            return supplierView;
        }
        $scope.addSupplierView = function (supplierView) {
            var index = $scope.dd.view.suppliersView.indexOf(supplierView);
            if (index == -1)
                $scope.dd.view.suppliersView.push(supplierView);
        };
        $scope.addVatView = function (vatView) {
            var index = $scope.dd.view.vatsView.indexOf(vatView);
            if (index == -1)
                $scope.dd.view.vatsView.push(vatView);
        }
        $scope.onSupplierInputKeyDown = function (event) {
            let keyCode = event.which;
            //if key delete detected : clear supplier
            if (keyCode == 8 || keyCode == 46) {
                if ($scope.dd.view.edited && $scope.dd.view.edited.productView)
                    $scope.dd.view.edited.productView.supplierView = null;

            }
        };
        $scope.onEnterKeyDown = function (event) {
            const ENTER_KEY_CODE = 13;
            let keyCode = event.which;

            if (keyCode === ENTER_KEY_CODE) {
                event.preventDefault();
                return false;
            }
        };
        $scope.getCfgClass = function (confItem, className) {
            if (confItem == $scope.dd.view.displaySubConf)
                return className;
            return "";
        };


//CATEGORY


        $scope.getCategoryView = function (category) {
            //Assume view index = model index
            var categoryView = $scope.dd.view.categoryRootView.getCategoryView(category);
            if (!categoryView) //must be deleted then instanciate it
            {
                var parentCategoryView = null;
                if (category.parentCategory)
                    parentCategoryView = $scope.getCategoryView(category.parentCategory);
                categoryView = new ProductCategoryView(category, ProductCategoryData.getIndexOf(category), parentCategoryView, $scope);

            }
            return categoryView;
        };
        $scope.onSearchProductInputKeyDown = function () {

            if ($scope.dd.view.categoryRootView) {
                $scope.dd.view.filterProductsView = null;
                if ($scope.dd.view.filterTimeOut)
                    $timeout.cancel($scope.dd.view.filterTimeOut);
                $scope.dd.view.filterTimeOut = $timeout(function () { //useTimeOut in order to search only when use finish typing (or barcode scanner stop)
                    if ($scope.dd.view.filter && $scope.dd.view.filter.length > 2)
                        $scope.dd.view.filterProductsView = $scope.dd.view.categoryRootView.getProductViewByCodeOrLabel($scope.dd.view.filter.toLowerCase());
                }, 250);


            }
        };
        $scope.createCategory = function (parentCategoryView) {
            if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            if ($scope.dd.view.edited.productView)
                if ($scope.dd.view.edited.productView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else {
                    $scope.dd.view.edited.productView.hrSkillsView = null;
                    $scope.dd.view.edited.productView.prSkillsView = null;
                    $scope.dd.view.edited.productView = null;
                }

            var categoryView = new ProductCategoryView(null, -1, parentCategoryView, $scope);
            if (parentCategoryView) {
                if (parentCategoryView.image)
                    categoryView.setImage(parentCategoryView.image);

                $scope.dd.view.edited.categoryView = categoryView;
                parentCategoryView.addCategoryView(categoryView);
            }
        };
        $scope.setCurrentCategory = function (category) {
            if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            if ($scope.dd.view.edited.productView)
                if ($scope.dd.view.edited.productView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else {
                    $scope.dd.view.edited.productView.hrSkillsView = null;
                    $scope.dd.view.edited.productView.prSkillsView = null;
                    $scope.dd.view.edited.productView = null;
                }

            if ($scope.dd.view.edited.categoryView)
                $scope.dd.view.edited.categoryView = null;

            $scope.dd.view.selected.categoryView = category;
        };
        $scope.setEditedCategory = function (categoryView) {
            if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            if ($scope.dd.view.edited.productView)
                if ($scope.dd.view.edited.productView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else {
                    $scope.dd.view.edited.productView.hrSkillsView = null;
                    $scope.dd.view.edited.productView.prSkillsView = null;
                    $scope.dd.view.edited.productView = null;
                }

            $scope.dd.view.edited.categoryView = categoryView;

            if ($scope.dd.view.tab > 2)
                $scope.dd.view.tab = 1;
        };
        $scope.saveEditedCategory = function () {
            if ($scope.dd.view.edited.categoryView)
                $scope.dd.view.edited.categoryView.updateModel();
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        };
        $scope.cancelEditedCategory = function () {
            $scope.dd.view.edited.categoryView.reloadModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        };
        $scope.afterRemoveCategory = function (category) {
            if (!category.parentCategory)//Remove from $scope
            {
                var index = $scope.categoryRoot.categories.indexOf(category);
                if (index != -1)
                    $scope.categoryRoot.categories.splice(index, 1);
                $scope.currentCategory = null;
            }
        };
        $scope.openDeletedCategoryViewConfirmDialog = function () {
            if ($scope.dd.view.edited.categoryView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result)
                        $scope.removeEditedCategory();
                });
            }
        };
        $scope.removeEditedCategory = function () {
            if ($scope.dd.view.edited.categoryView) {
                $scope.dd.view.edited.categoryView.removeModel();
                var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
                if (parentCategoryView)
                    parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
                $scope.dd.view.deletedCategoriesView.push($scope.dd.view.edited.categoryView);
                $scope.dd.view.edited.categoryView = null;
                $scope.displayChangeMsg = false;
            }

        };
        $scope.getClassForActiveCategory = function (category, className) {
            ////console.log("getClassForActive" + product.id);
            if (category === $scope.dd.view.edited.categoryView)
                return className;
            return "";
        };
        $scope.restoreCategory = function (categoryView) {
            if (categoryView) {
                if (categoryView.catIndex != -1)// retrieve old value from server
                    categoryView.restoreModel();
                var index = $scope.dd.view.deletedCategoriesView.indexOf(categoryView);
                if (index != -1) {
                    $scope.dd.view.deletedCategoriesView.splice(index, 1);
                    if (categoryView.parentCategoryView)
                        categoryView.parentCategoryView.addCategoryView(categoryView)
                }


            }

        };

        // PRODUCT
        $scope.getClassForActiveProduct = function (product, className) {
            ////console.log("getClassForActive" + product.id);
            if (product === $scope.dd.view.edited.productView)
                return className;
            return "";
        };
        $scope.createProduct = function () {
            if ($scope.dd.view.edited.categoryView)
                if ($scope.dd.view.edited.categoryView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else
                    $scope.dd.view.edited.categoryView = null;

            if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            var categoryView = $scope.dd.view.selected.categoryView;
            if (categoryView.catIndex == -1) {
                alert("Vous devez sauver une première fois la catégorie pour pouvoir lui ajouter des prestations.")
                return;
            }
            var newProductView = new ProductView(null, -1, categoryView, $scope);
            categoryView.addProductView(newProductView);

            if (categoryView.image && categoryView.image !== null)
                newProductView.setImage(categoryView.image);

            $scope.setEditedProduct(newProductView);
        };
        $scope.productClicked = function (productView) //Function linked to productsSelector.html
        {
            $scope.setEditedProduct(productView);
        };
        $scope.setEditedProduct = function (productView) {
            if ($scope.dd.view.edited.categoryView)
                if ($scope.dd.view.edited.categoryView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return false;
                } else
                    $scope.dd.view.edited.categoryView = null;
            if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.isChanged()) {
                $scope.displayChangeMsg = true;
                return false;
            }
            $scope.dd.view.edited.productView = productView;
            productView.getQuantityHistory();
            return true;
        };

        $scope.duplicateProduct = function (productView) {
            if ($scope.dd.view.edited.productView) {
                if ($scope.dd.view.edited.productView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                }
                $scope.dd.view.edited.productView = null;
            }
            if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            $scope.dd.view.edited.productView = productView.getClone();
            if ($scope.dd.view.edited.productView.label && $scope.dd.view.edited.productView.label != '') {
                $scope.dd.view.edited.productView.label = "Copie de " + $scope.dd.view.edited.productView.label;
            }
            if (productView.parentCategoryView) {
                productView.parentCategoryView.addProductView($scope.dd.view.edited.productView);
                if (productView.parentCategoryView.image) {
                    $scope.dd.view.edited.productView.setImage(productView.parentCategoryView.image);
                }
            }
        }

        $scope.saveEditedProduct = function () {
            if ($scope.dd.view.edited.productView) {
                $scope.dd.view.edited.productView.updateModel();
                $scope.dd.view.displayError = false;
                $scope.dd.view.edited.productView.hrSkillsView = null;
                $scope.dd.view.edited.productView.prSkillsView = null;
                $scope.dd.view.edited.productView = null;
                $scope.displayChangeMsg = false;
                $scope.dd.view.filterProductsView = null;
                $scope.dd.view.filter = "";
            }
        };
        $scope.cancelEditedProduct = function () {
            $scope.dd.view.edited.productView.reloadModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.productView.hrSkillsView = null;
            $scope.dd.view.edited.productView.prSkillsView = null;
            $scope.dd.view.edited.productView = null;
            $scope.dd.view.filterProductsView = null;
            $scope.dd.view.filter = "";
            $scope.displayChangeMsg = false;
        };
        $scope.openDeletedProductViewConfirmDialog = function () {
            if ($scope.dd.view.edited.productView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            tableModel["label"] = $scope.dd.view.edited.productView.label;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result)
                        $scope.removeEditedProduct();
                });
            }
        };
        $scope.removeEditedProduct = function () {
            if ($scope.dd.view.edited.productView) {
                $scope.dd.view.edited.productView.removeModel();
                var parentCategoryView = $scope.dd.view.edited.productView.parentCategoryView;
                if (parentCategoryView)
                    parentCategoryView.removeProductView($scope.dd.view.edited.productView);
                $scope.dd.view.deletedProductsView.push($scope.dd.view.edited.productView);
                $scope.dd.view.edited.productView.hrSkillsView = null;
                $scope.dd.view.edited.productView.prSkillsView = null;
                $scope.dd.view.edited.productView = null;
                $scope.dd.view.filterProductsView = null;
                $scope.dd.view.filter = "";
                $scope.displayChangeMsg = false;
            }
        };

        $scope.emptyTrash = function () {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/generalConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        var tableModel = [];
                        tableModel["question"] = gettextCatalog.getString("Voulez-vous vraiment vider la corbeille?");
                        tableModel["description"] = gettextCatalog.getString("Tous les produits de la corbeille vont être supprimés, l'action ne pourra pas être annulée après validation.");
                        return tableModel;
                    }
                }
            };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) {
                    ProductSrv.emptyTrash();
                    opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/infoDialog.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["label"
                                    ] = "La fonction de purge s'exécute sur le serveur et peut prendre jusqu'à 10 minutes. Il faudra ensuite actualiser pour constater le résultat.";
                                return tableModel;
                            }
                        }
                    };

                    $dialog.dialog(opts).open();
                }
            });
        }

        $scope.restoreProduct = function (productView) {
            if (productView) {
                if (productView.servIndex != -1)// retrieve old value from server
                    productView.restoreModel();
                var index = $scope.dd.view.deletedProductsView.indexOf(productView);
                if (index != -1) {
                    $scope.dd.view.deletedProductsView.splice(index, 1);
                    if (productView.parentCategoryView)
                        productView.parentCategoryView.addProductView(productView)
                }


            }

        };


//Assign image


        $scope.imageIsSelected = function (image) {
            if ($scope.dd.view.edited.productView) {
                if (!$scope.dd.view.edited.productView.companyImage && $scope.dd.view.edited.productView.image === image)
                    return true
            } else if (!$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image === image)
                return true

            return false;
        };

        $scope.companyImageIsSelected = function (companyImage) {
            if ($scope.dd.view.edited.productView && $scope.dd.view.edited.productView.companyImage === companyImage)
                return true
            if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage === companyImage)
                return true
            return false;
        };
        $scope.setImage = function (image) {
            if ($scope.dd.view.edited.productView) {
                if (image === $scope.dd.view.edited.productView.image) {
                    if ($scope.dd.view.edited.productView.image != null) {
                        $scope.dd.view.edited.productView.setImage(null);
                    } else {
                        $scope.dd.view.edited.productView.setImage($scope.dd.view.edited.productView.parentCategoryView.image);
                    }
                } else if (image != null) {
                    $scope.dd.view.edited.productView.setImage(image);
                } else {
                    $scope.dd.view.edited.productView.setImage($scope.dd.view.edited.productView.parentCategoryView.image);
                }
            }

            if ($scope.dd.view.edited.categoryView) {
                if (image === $scope.dd.view.edited.categoryView.image) {
                    if ($scope.dd.view.edited.categoryView.image != null) {
                        $scope.dd.view.edited.categoryView.setImage(null);
                    } else {
                        $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                    }
                } else if (image != null) {
                    $scope.dd.view.edited.categoryView.setImage(image);
                } else {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            }
        };
        $scope.setCompanyImage = function (companyImage) {
            if ($scope.dd.view.edited.productView) {
                if (companyImage === $scope.dd.view.edited.productView.companyImage) {
                    if ($scope.dd.view.edited.productView.companyImage != null) {
                        $scope.dd.view.edited.productView.setCompanyImage(null);
                    } else {
                        $scope.dd.view.edited.productView.setCompanyImage($scope.dd.view.edited.productView.parentCategoryView.companyImage);
                    }
                } else if (companyImage != null) {
                    $scope.dd.view.edited.productView.setCompanyImage(companyImage);
                } else {
                    $scope.dd.view.edited.productView.setCompanyImage($scope.dd.view.edited.productView.parentCategoryView.companyImage);
                }
            }

            if ($scope.dd.view.edited.categoryView) {
                if (companyImage === $scope.dd.view.edited.categoryView.companyImage) {
                    if ($scope.dd.view.edited.categoryView.companyImage != null) {
                        $scope.dd.view.edited.categoryView.setCompanyImage(null);
                    } else {
                        $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                    }
                } else if (companyImage != null) {
                    $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
                } else {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            }
        };

        // Suppliers
        $scope.setEditedSupplierView = function (supplierView) {
            if ($scope.dd.view.edited.supplierView && $scope.dd.view.edited.supplierView !== supplierView)
                $scope.dd.view.edited.supplierView.reloadModel();
            $scope.dd.view.edited.supplierView = supplierView;
        };
        $scope.createSupplier = function () {
            if ($scope.dd.view.edited.supplierView && $scope.dd.view.edited.supplierView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            var newSupplierView = new SupplierView(null, -1, $scope);
            $scope.dd.view.suppliersView.push(newSupplierView);
            $scope.dd.view.edited.supplierView = newSupplierView;
        };
        $scope.cancelEditedSupplierView = function () {
            if ($scope.dd.view.edited.supplierView.sIndex != -1)// retrieve old value from server
            {
                $scope.dd.view.edited.supplierView.reloadModel();
            } else {
                var index = $scope.dd.view.suppliersView.indexOf($scope.dd.view.edited.supplierView);
                if (index >= 0)
                    $scope.dd.view.suppliersView.splice(index, 1);
            }
            $scope.dd.view.edited.supplierView = null;
            $scope.displayError = false;
            $scope.displayChangeMsg = false;
        };
        $scope.saveEditedSupplierView = function () {
            if ($scope.dd.view.edited.supplierView)
                $scope.dd.view.edited.supplierView.updateModel();

            $scope.dd.view.edited.supplierView = null;
            $scope.displayError = false;
            $scope.displayChangeMsg = false;
        };
        $scope.removeEditedSupplierView = function () {

            if ($scope.dd.view.edited.supplierView) {
                if ($scope.dd.view.edited.supplierView.sIndex != -1)// retrieve old value from server
                    $scope.dd.view.edited.supplierView.removeModel();
                var index = $scope.dd.view.suppliersView.indexOf($scope.dd.view.edited.supplierView);
                if (index != -1) {
                    $scope.dd.view.suppliersView.splice(index, 1);
                }
                $scope.dd.view.edited.supplierView = null;
                $scope.displayError = false;
                $scope.displayChangeMsg = false;
            }
        };
        $scope.displaySupplierError = function () {
            $scope.dd.displayError = true;
            if ($scope.dd.view.edited.supplierView)
                $scope.dd.displayPhoneError = false;
            else
                $scope.dd.displayPhoneError = true;
            if ($scope.dd.view.edited.supplierView)
                $scope.dd.displayLandlineError = false;
            else
                $scope.dd.displayLandlineError = true;
        };
        $scope.openDeletedSupplierViewConfirmDialog = function () {
            if ($scope.dd.view.edited.supplierView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            tableModel["label"] = $scope.dd.view.edited.supplierView.label;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result)
                        $scope.removeEditedSupplierView();
                });
            }
        };
        $scope.getEditedItem = function () {
            return $scope.dd.view.edited.categoryView ? $scope.dd.view.edited.categoryView : ($scope.dd.view.edited.productView ? $scope.dd.view.edited.productView : null);
        };
    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/productCtrl.js